import React from 'react';
import { Brain, X } from 'lucide-react';

interface GeneratorHeaderProps {
  childName: string;
  isGenerating: boolean;
  onClose: () => void;
}

export function GeneratorHeader({ childName, isGenerating, onClose }: GeneratorHeaderProps) {
  return (
    <div className="bg-gradient-to-r from-purple-500 via-blue-500 to-indigo-600 px-6 py-4 text-white rounded-t-2xl">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-white bg-opacity-20 rounded-lg">
            <Brain className="w-6 h-6" />
          </div>
          <div>
            <h2 className="text-xl font-bold">AI Activity Generator</h2>
            <p className="text-blue-100">Powered by Requesty.ai - Create personalized learning for {childName}</p>
          </div>
        </div>
        {!isGenerating && (
          <button
            onClick={onClose}
            className="p-2 hover:bg-white hover:bg-opacity-20 rounded-lg transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        )}
      </div>
    </div>
  );
}
